export type AppState = {
    enteredInformation: boolean,
    firstName: string,
    lastName: string,
    showChat: boolean,
    lastMessage: string,
    hasOpened: boolean,
    hasShownPrompt: boolean,
    lastLocation: string,
    shrinkWidget: boolean,
    isLandscape: boolean
}


export const initialState: AppState = {
    enteredInformation: false,
    firstName: "",
    lastName: "",
    showChat: false,
    hasOpened: false,
    hasShownPrompt: false,
    lastMessage: "",
    lastLocation: "",
    shrinkWidget: false,
    isLandscape: true
}

export type AppAction =
    | { type: 'setEnteredInformation', hasEnteredInformation: boolean }
    | { type: 'setShowChat', showChat: boolean }
    | { type: 'setShrinkWidget', shrinkWidget: boolean }
    | { type: 'setHasOpened', hasOpened: boolean }
    | { type: 'setLastLocation', location: string }
    | { type: 'setIsLandscape', isLandscape: boolean }
    | { type: 'setAppState', appState: AppState }

export const storageIdentifier = "edullaStartChat"

const updateStateAndStoreInStorage = (state: AppState): AppState => {
    localStorage.setItem(getStorageIdentifier(), JSON.stringify(state));
    return state;
}

let getStorageIdentifier = () => {
    return storageIdentifier + sessionStorage.getItem("edullaTid")
}

export const getCachedAppState = (): AppState => {
    let appStateStorage = localStorage.getItem(getStorageIdentifier())
    if (appStateStorage) {
        return JSON.parse(appStateStorage);
    }
    return initialState
}

export const startReducer = (state: AppState, action: AppAction) => {
    switch (action.type) {
        case "setEnteredInformation":
            return updateStateAndStoreInStorage({ ...getCachedAppState(), enteredInformation: action.hasEnteredInformation });
        case "setShowChat":
            return updateStateAndStoreInStorage({ ...getCachedAppState(), showChat: action.showChat });
        case "setHasOpened":
            return updateStateAndStoreInStorage({ ...getCachedAppState(), hasOpened: action.hasOpened });
        case "setLastLocation":
            return updateStateAndStoreInStorage({ ...getCachedAppState(), lastLocation: action.location });
        case "setShrinkWidget":
            return updateStateAndStoreInStorage({ ...getCachedAppState(), shrinkWidget: action.shrinkWidget });
        case "setIsLandscape":
            return updateStateAndStoreInStorage({ ...getCachedAppState(), isLandscape: action.isLandscape });
        case "setAppState":
            return updateStateAndStoreInStorage(action.appState);
        default:
            return getCachedAppState();
    }
};
